<template>
  <div class="mutualsettlements-table" v-if="mutualsettlementsList.length > 0">

    <div class="table">

    <div class="col head document"><span>Документ движения</span></div>
    <div class="col head"><span>Нач. остаток</span></div>
    <div class="col head"><span>Приход</span></div>
    <div class="col head"><span>Расход</span></div>
    <div class="col head"><span>Кон. остаток</span></div>
    <div class="col head last"><span></span></div>

    <template v-for="(mutualsettlement, index) in mutualsettlementsList" :key="index">
      <div class="col val d1 document" :class="[{opened: mutualsettlement.opened}]"><span>{{mutualsettlement.company}}</span></div>
      <div class="col val d1" :class="[{opened: mutualsettlement.opened}]"><span>{{mutualsettlement.opening_balance}}</span></div>
      <div class="col val d1" :class="[{opened: mutualsettlement.opened}]"><span>{{mutualsettlement.income}}</span></div>
      <div class="col val d1" :class="[{opened: mutualsettlement.opened}]"><span>{{mutualsettlement.expense}}</span></div>
      <div class="col val d1 pre_last" :class="[{opened: mutualsettlement.opened}]"><span>{{mutualsettlement.closing_balance}}</span></div>
      <div class="col val d1 last" :class="[{opened: mutualsettlement.opened}]" @click="openCompany(mutualsettlement)">
        <svg class="open" :class="[{opened: mutualsettlement.opened}]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5.83398 8.33334L10.0007 11.6667L14.1673 8.33334" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <template v-for="doc2 in mutualsettlement.l2" :key="doc2">
        <div v-if="mutualsettlement.opened" class="col val d2 document"><span>{{doc2.deal}}</span></div>
        <div v-if="mutualsettlement.opened" class="col val d2"><span>{{doc2.opening_balance}}</span></div>
        <div v-if="mutualsettlement.opened" class="col val d2"><span>{{doc2.income}}</span></div>
        <div v-if="mutualsettlement.opened" class="col val d2"><span>{{doc2.expense}}</span></div>
        <div v-if="mutualsettlement.opened" class="col val d2 pre_last"><span>{{doc2.closing_balance}}</span></div>
        <div v-if="mutualsettlement.opened" class="col val d2 last" @click="openDeal(doc2)">
          <svg class="open" :class="[{opened: doc2.opened}]"  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5.83398 8.33334L10.0007 11.6667L14.1673 8.33334" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <template v-for="doc3 in doc2.l3" :key="doc3">
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3 document"><span>{{doc3.document}}</span></div>
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3"><span>{{doc3.opening_balance}}</span></div>
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3"><span>{{doc3.income}}</span></div>
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3"><span>{{doc3.expense}}</span></div>
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3 pre_last"><span>{{doc3.closing_balance}}</span></div>
          <div v-if="mutualsettlement.opened && doc2.opened" class="col val d3 last" @click="openDocument(doc3)">
            <svg class="open" :class="[{opened: doc3.opened}]"  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5.83398 8.33334L10.0007 11.6667L14.1673 8.33334" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <template v-for="doc4 in doc3.l4" :key="doc4">
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4 document"><span>{{doc4.document}}</span></div>
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4"><span>{{doc4.opening_balance}}</span></div>
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4"><span>{{doc4.income}}</span></div>
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4"><span>{{doc4.expense}}</span></div>
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4 pre_last"><span>{{doc4.closing_balance}}</span></div>
            <div v-if="mutualsettlement.opened && doc2.opened && doc3.opened" class="col val d4 last"></div>
          </template>

        </template>

      </template>

    </template>

    <template v-if="mutualsettlementsTotal">
      <div class="col val total document"><span>Итог</span></div>
      <div class="col val total"><span>{{mutualsettlementsTotal.opening_balance}}</span></div>
      <div class="col val total"><span>{{mutualsettlementsTotal.income}}</span></div>
      <div class="col val total"><span>{{mutualsettlementsTotal.expense}}</span></div>
      <div class="col val total pre_last"><span>{{mutualsettlementsTotal.closing_balance}}</span></div>
      <div class="col val total last"></div>
    </template>

    </div>



    <div class="mobile-table">
      <div class="item" v-for="(mutualsettlement, index) in mutualsettlementsList" :key="index">
        <div class="rows">
          <div class="row">
            <span class="desc">Период</span>
            <span class="val">01.02.2024 – 21.02.2024</span>
          </div>
          <div class="row document">
            <span class="desc">Документ движения</span>
            <span class="val">{{mutualsettlement.company}}</span>
          </div>
          <div class="row">
            <span class="desc">Нач. остаток</span>
            <span class="val">{{mutualsettlement.opening_balance}}</span>
          </div>
          <div class="row">
            <span class="desc">Приход</span>
            <span class="val">{{mutualsettlement.income}}</span>
          </div>
          <div class="row">
            <span class="desc">Расход</span>
            <span class="val">{{mutualsettlement.expense}}</span>
          </div>
          <div class="row">
            <span class="desc">Кон. Остаток</span>
            <span class="val">{{mutualsettlement.closing_balance}}</span>
          </div>
        </div>
      </div>
    </div>



    <div class="table-bottom" v-if="false">
      <span class="total">
        Показано 10 из 32 результатов
      </span>
      <div class="pagination">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
          <g opacity="0.5">
            <path d="M10 17L6 12L10 7" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>

        <div class="page current"><span>1</span></div>
        <div class="page"><span>2</span></div>
        <div class="page"><span>3</span></div>
        <div class="page"><span>4</span></div>
        <div class="page"><span>5</span></div>

        <div class="dots"><span>...</span></div>

        <div class="page"><span>12</span></div>

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
          <path d="M6 7L10 12L6 17" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

      </div>
    </div>

    <div class="table-bottom" v-if="false">
      <span class="total">
        Показано 4 из 4 результатов
      </span>
      <div class="pagination">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
            <path d="M10 17L6 12L10 7" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <div class="page current"><span>1</span></div>

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
          <path d="M6 7L10 12L6 17" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

      </div>
    </div>

  </div>
</template>

<script>



export default {
  name: 'MutualsettlementsTable',
  props : {
    not_available : Boolean
  },
  components: {
  },
  data() {
    return{
      mutualsettlementsList : [],
      mutualsettlementsTotal : [],
      /*mutualsettlementsList : [
        {
          company : "ИП Русские пряники",
          opened : false,
          opening_balance : "134 093, 20",
          income : "124 626,76",
          expense : "258 719,96",
          closing_balance : "0",
          total : {
            opening_balance : "134 093, 20",
            income : "124 626,76",
            expense : "258 719,96",
            closing_balance : "",
          },
          l2 : [
            {
              deal : "Договор поставки с отсрочкой №0-22/08/24-КА, руб.",
              opened : false,
              opening_balance : "104 040,35",
              income : "27 704,88",
              expense : "",
              closing_balance : "131 746,23",
              l3 : [
                {
                  document : "Платежное поручение входящее УТ0000004397 от 19.09.2019",
                  opening_balance : "-122 856,93",
                  income : "",
                  expense : "",
                  closing_balance : "-122 856,93"
                },
                {
                  document : "Реализация товаров и услуг УТ0000004391",
                  opening_balance : "117 258,62",
                  income : "",
                  expense : "",
                  closing_balance : "117 258,62"
                },
                {
                  document : "Реализация товаров и услуг УТ0000004391",
                  opening_balance : "9 232,55",
                  income : "",
                  expense : "",
                  closing_balance : "9 232,55"
                },
                {
                  document : "Платежное поручение входящее УТ0000004397 от 18.11.2019",
                  opening_balance : "-7 351,84",
                  income : "",
                  expense : "",
                  closing_balance : "-7 351,84"
                },
              ]
            },
            {
              deal : "Договор поставки с отсрочкой №0-05/04/23-ЕК, руб.",
              opened : false,
              opening_balance : "30 052,85",
              income : "96 921,88",
              expense : "258 719,96",
              closing_balance : "-131 746,23",
              l3 : [
                {
                  document : "Платежное поручение входящее УТ0000004397 от 19.09.2019",
                  opening_balance : "-122 856,93",
                  income : "",
                  expense : "",
                  closing_balance : "-122 856,93"
                },
                {
                  document : "Реализация товаров и услуг УТ0000004391",
                  opening_balance : "117 258,62",
                  income : "",
                  expense : "",
                  closing_balance : "117 258,62"
                },
              ]
            }
          ]
        },
        {
          company: "ООО «Ромашка»",
          opened : false,
          opening_balance : "134 093, 20",
          income : "124 626,76",
          expense : "258 719,96",
          closing_balance : "0",
          total : {
            opening_balance : "134 093, 20",
            income : "124 626,76",
            expense : "258 719,96",
            closing_balance : "0",
          },
        },
        {
          company: "ООО «Luckru»",
          opened : false,
          opening_balance : "134 093, 20",
          income : "124 626,76",
          expense : "258 719,96",
          closing_balance : "0",
          total : {
            opening_balance : "134 093, 20",
            income : "124 626,76",
            expense : "258 719,96",
            closing_balance : "",
          },
        },
        {
          company: "ИП Иванов",
          opened : false,
          opening_balance : "134 093, 20",
          income : "124 626,76",
          expense : "258 719,96",
          closing_balance : "0",
          total : {
            opening_balance : "134 093, 20",
            income : "124 626,76",
            expense : "258 719,96",
            closing_balance : "",
          },
        },
      ]*/
    }
  },
  mounted() {

  },
  methods : {
    openCompany : function(mutualsettlement) {
      mutualsettlement.opened = !mutualsettlement.opened;
    },
    openDeal : function(doc2) {
      doc2.opened = !doc2.opened;
    },
    openDocument : function(doc3) {
      doc3.opened = !doc3.opened;
    },
  }
}
</script>



<style scoped>

.mutualsettlements-table .table{
  width: 100%;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;
  display: grid;
  grid-template-columns: min-content auto auto auto auto min-content;
}

.col {
  padding: 14px 20px;
  text-align: center;
}

.col.head.document, .col.val.document {
  text-align: start;
  justify-content: start;
  white-space: nowrap;
}

.col.head.document span, .col.val.document span {

}



.col.head {
  border-right: 1px solid var(--Border, #EDEDED);
}
.col.head.last {
  border-right: unset;
}

.col.head span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.col.val {
  border-top: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  justify-content: center;
}


.col.val.last {
  border-right: unset;
}

.col.val.last .open {
  cursor: pointer;
  transition: 0.5s;
}

.open.opened {
  transform: rotate(180deg);
  transition: 0.5s;
}

.col.val.pre_last {
  border-right: 1px solid var(--Border, #EDEDED);
}

.col.val span{
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.col.val.d1.opened {
  background: var(--BG, #F8F8F8);
}

.col.val.d1 span{
  font-weight: 500;
}

.col.val.d2.document {
  padding-left: 30px;
}

.col.val.d2 span{
  font-weight: 500;
}

.col.val.d3.document {
  padding-left: 40px;
}

.col.val.d4.document {
  padding-left: 50px;
}

.col.total {
  background: rgba(27, 120, 188, 0.10);
}

.col.total span{
  font-weight: 500;
}

.col.val.hover {
  background: var(--BG, #F8F8F8);
}








.table-bottom {
  padding: 16px 20px;
  border: 1px solid var(--Border, #EDEDED);
  border-top: unset;
  background: var(--White);
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-bottom .total {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.table-bottom .pagination {
  display: flex;
  align-items: center;
  gap: 16px;
}

.table-bottom .pagination svg {
  cursor: pointer;
}

.table-bottom .pagination span{
  color: var(--Gray, #656565);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  cursor: pointer;
}

.table-bottom .pagination .page.current {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--Blue, #1B78BC);
  color: var(--White, #FFF);
  cursor: pointer;
}

.table-bottom .pagination .page.current span {
  color: var(--White, #FFF);
}







.mobile-table {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .mutualsettlements-table .table {
    display: none;
  }

  .table-bottom {
    flex-direction: column;
    gap: 14px;
    padding: 18px;
  }

  .mobile-table {
    display: block;
    border: 1px solid var(--Border, #EDEDED);
    background: var(--White, #FFF);
    box-sizing: border-box;
    border-radius: 8px 8px 0px 0px;
  }

  .mobile-table .item {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 18px;
    background: var(--White);
    border-bottom: 1px solid var(--Border, #EDEDED);
  }

  .mobile-table .item:first-child {
    border-radius: 8px 8px 0px 0px;
  }

  .mobile-table .item:last-child {
    border-bottom: unset;
  }

  .mobile-table .item .rows {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-table .item .row {
    display: flex;
    justify-content: space-between;
  }

  .mobile-table .item .row.document {
    flex-direction: column;
    align-items: start;
    justify-content: start;
    gap: 6px;
  }

  .mobile-table .item .row .desc {
    color: var(--Gray, #656565);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .mobile-table .item .row .val {
    color: var(--Black, #222);
    text-align: right;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .mobile-table .standart_button {
    height: 38px;
    max-height: 38px;
  }
}
</style>



<style>

.col.buttons .standart_button {
  height: 38px;
  width: 120px;
}



/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>